import { ObjectLike } from '@/types/objectlike.types';
import { iUser } from './user.types';

export default class User implements iUser {
  readonly id: string;

  readonly username: string;

  readonly email: string;

  readonly gamertag: string;

  readonly profilePic: string | null;

  readonly profileCover: string | null;

  readonly slug: string | null;

  emailVerified = false;

  constructor(
    id: string,
    username: string,
    email: string,
    gamertag: string,
    emailVerified = false,
    profilePic: string | null = null,
    profileCover: string | null = null,
    slug: string | null = null,
  ) {
    this.id = id;
    this.gamertag = gamertag;
    this.email = email;
    this.username = username;
    this.emailVerified = emailVerified;
    this.profileCover = profileCover;
    this.profilePic = profilePic;
    this.slug = slug;
  }

  toObject(): ObjectLike {
    return {
      id: this.id,
      gamertag: this.gamertag,
      email: this.email,
      username: this.username.trim().toLowerCase(),
      emailVerified: this.emailVerified,
      profilePic: this.profilePic,
      profileCover: this.profileCover,
      slug: this.slug,
    };
  }
}
